import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import {
  LiteLLMBudgetGauges,
  LiteLLMBudgetWidget,
  LiteLLMHomeWidget,
} from '@internal/plugin-litellm';
import { CatalogOverview } from './CatalogOverview';

const catalogOverviewWidget = HomePageWidgetBlueprint.make({
  name: 'catalog-overview',
  params: {
    name: 'CatalogOverview',
    title: 'Catalog',
    description: 'Live entity counts, linking through to the catalog',
    components: async () => ({ Content: () => <CatalogOverview /> }),
  },
});

const litellmUsageWidget = HomePageWidgetBlueprint.make({
  name: 'litellm-usage',
  params: {
    name: 'LiteLLMUsage',
    title: 'LiteLLM Usage',
    description: 'Your spend, tokens and key count against the LLM proxy',
    // `frame: false` because the home grid draws the card and heading itself;
    // the widget would otherwise render a second card inside the first.
    components: async () => ({
      Content: () => <LiteLLMHomeWidget frame={false} />,
    }),
  },
});

const litellmBudgetWidget = HomePageWidgetBlueprint.make({
  name: 'litellm-budget',
  params: {
    name: 'LiteLLMBudget',
    title: 'LiteLLM Budget Policy',
    description:
      'How the proxy caps your spend, with a live meter on each limit you have',
    components: async () => ({
      Content: () => <LiteLLMBudgetWidget frame={false} compact />,
    }),
  },
});

const litellmBudgetGaugesWidget = HomePageWidgetBlueprint.make({
  name: 'litellm-budget-gauges',
  params: {
    name: 'LiteLLMBudgetGauges',
    title: 'LiteLLM Budget',
    description:
      "Today's and month-to-date spend, with a ring per key, personal and team cap",
    components: async () => ({
      Content: () => <LiteLLMBudgetGauges frame={false} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    catalogOverviewWidget,
    litellmUsageWidget,
    litellmBudgetWidget,
    litellmBudgetGaugesWidget,
  ],
});
